import { render } from "./feedList.vue?vue&type=template&id=cb75d880&scoped=true"
import script from "./feedList.vue?vue&type=script&lang=js"
export * from "./feedList.vue?vue&type=script&lang=js"

import "./feedList.vue?vue&type=style&index=0&id=cb75d880&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb75d880"]])

export default __exports__